import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";
function CreditOrigination() {
  document.title = "Ditobanx";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Credit Origination"
            breadcrumbItem="Credit Origination"
          />
          <h4>Credit Origination</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default CreditOrigination;
